import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	dismissButtonLabel: {
		id: 'des-share-link.hooks.dismiss-button-label',
		defaultMessage: 'Dismiss',
		description: 'Label for the dismiss button on the call to action banner',
	},
	bannerTitle: {
		id: 'des-share-link.hooks.banner-title',
		defaultMessage: 'Start collaborating with your team',
		description: 'Title for the collaboration banner',
	},
	bannerText: {
		id: 'des-share-link.hooks.banner-text',
		defaultMessage:
			'People with {domain} email addresses have access to this project, so simply send them a link to join.',
		description: 'Main text for the collaboration banner',
	},
	actionText: {
		id: 'des-share-link.hooks.action-text',
		defaultMessage: 'Copy link',
		description: 'Text for the action button to copy the share link',
	},
	copyToClipboardSuccess: {
		id: 'des-share-link.hooks.copy-to-clipboard-success',
		defaultMessage: 'Link copied, ready to share!',
		description: 'Success message when the share link is copied to the clipboard',
	},
	copyToClipboardError: {
		id: 'des-share-link.hooks.copy-to-clipboard-error',
		defaultMessage: 'Failed to copy to clipboard',
		description: 'Error message when the share link fails to copy to the clipboard',
	},
});
